import { render, staticRenderFns } from "./RainTankDetail.vue?vue&type=template&id=3a889b81&scoped=true&"
import script from "./RainTankDetail.vue?vue&type=script&lang=js&"
export * from "./RainTankDetail.vue?vue&type=script&lang=js&"
import style0 from "./RainTankDetail.vue?vue&type=style&index=0&id=3a889b81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a889b81",
  null
  
)

export default component.exports